// ============================================================
// api/adminNotificationLog.js — worklist D15 (2026-08-16)
// Binding for GET /mgmt/admin/notification-log — the first read of the
// per-recipient delivery trail since Phase 2 shipped it write-only.
//
// Backend reference:
//   backend/func-carehub-api/src/functions/admin-notification-log.js
// ============================================================

import { apiGet } from './client';

// Paths are relative to the API base and must NOT carry an `/api` prefix —
// the client adds it (the doubled-prefix class that shipped six dead admin
// surfaces on 2026-08-04).

/**
 * List notification delivery rows, newest first, bounded (truncated flag).
 * byStatus honours clientId/channel/days but NEVER the status filter, so
 * the failure chips stay honest while the rows narrow.
 *
 * @param {Object} [params={}]
 * @param {number} [params.clientId]
 * @param {string} [params.channel]  teams|email|in_app|internal_email|internal_teams
 * @param {string} [params.status]   pending|sent|delivered|failed|bounced|suppressed|quarantined|filtered_spam|expanded
 * @param {number} [params.days=7]   1..90
 */
export function listNotificationLog(params = {}) {
  const qs = new URLSearchParams();
  if (params.clientId != null && params.clientId !== '') qs.set('clientId', String(params.clientId));
  if (params.channel) qs.set('channel', params.channel);
  if (params.status) qs.set('status', params.status);
  if (params.days != null) qs.set('days', String(params.days));
  const q = qs.toString();
  return apiGet(`/mgmt/admin/notification-log${q ? `?${q}` : ''}`);
}
